/* eslint-disable max-classes-per-file */
import AdBridgeAsidePanel from 'client/directories/ActiveDirectory/AdBridgeAsidePanel.vue';
import AlertWrapper from 'client/components/Alert/AlertWrapper';
import ApplicationAsidePanel from 'client/applications/ApplicationAsidePanel.vue';
import ApplicationChooserAsidePanel from 'client/applications/ApplicationChooserAsidePanel.vue';
import ApplicationMainPanel from 'client/applications/ApplicationMainPanel.vue';
import AuthNPoliciesAsidePanelLegacy from 'client/Security/AuthNPoliciesAsidePanel/AuthNPoliciesAsidePanelLegacy.vue';
import AuthNPoliciesMainPanel from 'client/Security/AuthNPoliciesMainPanel.vue';
import AuthNPoliciesSettings from 'client/Security/AuthNPoliciesSettings.vue';
import BlankMainPanel from 'client/components/BlankMainPanel.vue';
import ConfigurationGroupAsidePanel from 'client/groups/Configuration/ConfigurationGroupAsidePanel.vue';
import DirectoriesMainPanel from 'client/directories/DirectoriesMainPanel.vue';
import GSuiteAsidePanel from 'client/directories/GSuite/GSuiteAsidePanel.vue';
import GroupsMainPanel from 'client/components/MainPanel/GroupsMainPanel.vue';
import MdmVppMainPanel from 'client/MDM/MdmVppMainPanel';
import Modal from 'client/components/Modal/Modal.vue';
import O365AsidePanel from 'client/directories/Office365/O365AsidePanel.vue';
import ProgressModal from 'client/components/Modal/ProgressModal.vue';
import ReportsMainPanel from 'client/Reports/ReportsMainPanel.vue';
import SystemGroupAsidePanel from 'client/groups/System/SystemGroupAsidePanel.vue';
import TheModal from 'client/components/Modal/TheModal.vue';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import WorkdayAsidePanel from 'client/directories/Workday/WorkdayAsidePanel.vue';
import store from 'client/store';

/**
 * New Navigation Feature Flags
 * @todo Remove when going GA for navigation
 */

// ----------------------------------------------------------------------------
// This file provides accessor methods used to wrap Vue.js components in simple
// JavaScript methods so they can be included and used in existing Backbone
// views with minimal setup.
// ----------------------------------------------------------------------------

export const renderAlert = AlertWrapper;

/**
 * This class is a generic wrapper for Vue components. It is not meant to be
 * instantiated directly but instead should be extended so that the child class
 * can specify the proper component.
 */
export class ComponentWrapper {
  constructor(el, data = {}, component) {
    this.el = el;
    this.data = data;
    this.vm = null;
    this.component = component;
  }

  render() {
    const { data, component } = this;

    // Bind data from parent Backbone view to props on child Vue compoment so
    // that changes to data in the parent will be updated in the child's props.
    this.vm = new Vue({
      el: this.el,

      name: component,

      data() {
        return data;
      },

      provide: {
        $validator: new VeeValidate.Validator(),
      },

      // eslint-ignore-next-line object-shorthand
      render: function render(h) {
        return h(component, {
          props: this.$data,
        });
      },

      store,
    });
  }

  on(eventName, eventHandler) {
    this.vm.$children[0].$on(eventName, eventHandler);
  }

  /**
   * @todo This code is copied from below. How can it be reused in both the
   * ComponentWrapper and ItemTableWrapper? Should a generic Wrapper base class
   * be introduced? Note that this is _NOT_ the first method that is present in
   * both the ItemTableWrapper and the ComponentWrapper!
   */
  setElement(el) {
    this.el = el instanceof window.jQuery ? el.get(0) : el;
    return this;
  }

  cleanUp() {
    if (this.vm.$children[0]) this.vm.$children[0].$destroy();
    this.vm = null;
  }

  getComponent() {
    return this.vm.$children[0];
  }

  hasModelChanged() {
    // The ViewModel's child component may have already been destroyed here. So
    // in this case just catch the error and return false.
    try {
      return this.vm.$children[0].hasModelChanged();
    } catch (exp) {
      return false;
    }
  }

  isModelProcessing() {
    // The ViewModel's child component may have already been destroyed here. So
    // in this case just catch the error and return false.
    try {
      return this.vm.$children[0].isModelProcessing();
    } catch (exp) {
      return false;
    }
  }

  getModelProcessingData() {
    // The ViewModel's child component may have already been destroyed here. So
    // in this case just catch the error and return null.
    try {
      return this.vm.$children[0].getModelProcessingData();
    } catch (exp) {
      return null;
    }
  }
}

export class SlottedComponentWrapper extends ComponentWrapper {
  constructor(el, data, slotContent, component) {
    super(el, data, component);
    this.slotContent = slotContent;
  }

  render() {
    const { data, component, slotContent } = this;
    this.vm = new Vue({
      el: this.el,

      name: component,

      data() {
        return data;
      },

      // eslint-ignore-next-line object-shorthand
      render: function render(h) {
        return h(component, {
          props: this.$data,
          scopedSlots: {
            default: () => h('div', { domProps: { innerHTML: slotContent } }),
          },
        });
      },

      store,
    });
  }
}

export class AsidePanelWrapper extends ComponentWrapper {
  constructor(el, data = {}, component) {
    super(el, data, component);
  }
}

export class ApplicationChooserAsidePanelWrapper extends AsidePanelWrapper {
  constructor(el, data, component = ApplicationChooserAsidePanel) {
    super(el, data, component);
  }
}

export class AdBridgeAsidePanelWrapper extends AsidePanelWrapper {
  constructor(el, data, component = AdBridgeAsidePanel) {
    super(el, data, component);
  }
}

export class AuthNPoliciesAsidePanelWrapper extends ComponentWrapper {
  constructor(el, data, component = AuthNPoliciesAsidePanelLegacy) {
    super(el, data, component);
  }
}

export class AuthNPoliciesSettingsWrapper extends ComponentWrapper {
  constructor(el, data, component = AuthNPoliciesSettings) {
    super(el, data, component);
  }
}

export class AuthNPoliciesMainPanelWrapper extends ComponentWrapper {
  constructor(el, data, component = AuthNPoliciesMainPanel) {
    super(el, data, component);
  }
}

export class BlankMainPanelWrapper extends ComponentWrapper {
  constructor(el, data, component = BlankMainPanel) {
    super(el, data, component);
  }
}

export class DirectoriesMainPanelWrapper extends ComponentWrapper {
  constructor(el, data, component = DirectoriesMainPanel) {
    super(el, data, component);
  }
}

export class GroupsMainPanelWrapper extends ComponentWrapper {
  constructor(el, data) {
    super(el, data, GroupsMainPanel);
  }
}

export class GSuiteAsidePanelWrapper extends AsidePanelWrapper {
  constructor(el, data) {
    super(el, data, GSuiteAsidePanel);
  }
}

export class MdmSettingsMainPanelWrapper extends ComponentWrapper {
  constructor(el, data, component = MdmVppMainPanel) {
    super(el, data, component);
  }
}

export class ModalWrapper extends SlottedComponentWrapper {
  constructor(el, data, slotContent) {
    super(el, data, slotContent, Modal);
  }
}

export class O365AsidePanelWrapper extends AsidePanelWrapper {
  constructor(el, data, component = O365AsidePanel) {
    super(el, data, component);
  }
}
export class ConfigurationGroupAsidePanelWrapper extends ComponentWrapper {
  constructor(el, data, component = ConfigurationGroupAsidePanel) {
    super(el, data, component);
  }
}

export class ProgressModalWrapper extends ComponentWrapper {
  constructor(el, data) {
    super(el, data, ProgressModal);
  }

  updateProgressModal(completed, total) {
    this.vm.$children[0].updateProgressModal(completed, total);
  }

  hideProgressModal() {
    this.vm.$children[0].hideProgressModal();
  }

  /**
   * If the ProgressModal is visible then wait for it to be closed before
   * cleaning up the VM. This is necessary because if the ProgressModal is
   * destroyed before the Modal it renders is closed, the Modal will remain
   * open blocking the user from interacting with the site.
   */
  cleanUp() {
    return new Promise((resolve) => {
      const handleCleanUp = () => {
        super.cleanUp();
        resolve();
      };

      if (this.vm.$children[0].visible) {
        this.vm.$children[0].$on('closed', () => handleCleanUp());
      } else {
        handleCleanUp();
      }
    });
  }
}

export class ReportsMainPanelWrapper extends ComponentWrapper {
  constructor(el, data, component = ReportsMainPanel) {
    super(el, data, component);
  }
}

export class SystemGroupAsidePanelWrapper extends AsidePanelWrapper {
  constructor(el, data) {
    super(el, data, SystemGroupAsidePanel);
  }
}

export class TheModalWrapper extends ComponentWrapper {
  constructor(el, data) {
    super(el, data, TheModal);
  }
}

export class WorkdayAsidePanelWrapper extends AsidePanelWrapper {
  constructor(el, data, component = WorkdayAsidePanel) {
    super(el, data, component);
  }
}

export class ApplicationMainPanelWrapper extends ComponentWrapper {
  constructor(el, data, component = ApplicationMainPanel) {
    super(el, data, component);
  }
}

export class ApplicationAsidePanelWrapper extends ComponentWrapper {
  constructor(el, data, component = ApplicationAsidePanel) {
    super(el, data, component);
  }
}
